module.exports = __webpack_public_path__ + "img/logo-w-vertical.8d816a4f.png";